export const QUOTES_DATA = [
  {
    quote: "Sure, a big cut or a bunch of little ones?",
    character: "Yerin",
    advancement: "Underlord",
    book: "Uncrowned"
  },
  {
    quote: "This is the world we worked for! We don’t owe it to anyone.",
    character: "Reigan Shen",
    advancement: "Monarch",
    book: "Waybound"
  },

  {
    quote: "Really? I could have sworn I heard my name.",
    character: "Eithan",
    advancement: "Overlord",
    book: "Wintersteel"
  },
  {
    quote: "My fate...does not...end here...",
    character: "Longhook",
    advancement: "Underlord",
    book: "Ghostwater"
  },
  {
    quote: "Attend me closely, for this is ancient knowledge. There is only one thing that can kill the Dreadgods: points.",
    character: "Elder Whisper",
    advancement: "Truegold",
    book: "Reaper"
  },
  {
    quote: "They are real, but they aren’t precisely here. These are just the projections of those treasures I’ve collected that are so significant they intrude even on depictions of the place.",
    character: "Suriel",
    advancement: "Ascended",
    book: "Bloodline"
  },
  {
    quote: "Pardon my ignorance, but isn’t that normal?",
    character: "Lindon",
    advancement: "Iron",
    book: "Blackflame"
  },
  {
  quote: "Even dragons, know when to bow.",
    character: "Orthos",
    advancement: "Truegold",
    book: "Skysworn"
  },
  {
  quote: "There’s a reason, besides his infamous eccentricity and dramatic flair, that he built this facility on the back of a flying sacred beast. ",
    character: "Dross",
    advancement: "Dross",
    book: "Dreadgod"
  },
  {
  quote: "Not gonna bleed out, but scrubbing out a couple of pups might get…sticky.",
    character: "Yerin",
    advancement: "Lowgold",
    book: "Soulsmith"
  },
  {
  quote: "It’s hard to be correct all the time,” Ozmanthus said. “Almost as hard as it is to be so handsome. You may praise me again.",
  character: "Ozmanthus Arelius",
  advancement: "Ascended",
  book: "Dreadgod"
  },
  {
  quote: "Who's Dross?",
  character: "Northstrider",
  advancement: "Monarch",
  book: "Wintersteel"
  },
  {
  quote: "Don't push yourself too hard. If they shame you too badly, I'll pay them back in the Iron trials.",
  character: "Wei Shi Kelsa",
  advancement: "Iron",
  book: "Unsouled"
  },
  {
  quote: "Dragon Fever",
  character: "Yerin",
  advancement: "Jade",
  book: "Unsouled"
  },
   {
  quote: "I think he was looking forward to me trying it. I found several constructs in his outer robe before he veiled them. He had recorded responses ahead of time.",
  character: "Lindon",
  advancement: "Sage",
  book: "Dreadgod"
  },
   {
  quote: "Make the offer, And please, don’t leave without taking some of them with you. Emphasize families with children.",
  character: "Ziel",
  advancement: "Underlord",
  book: "Bloodline"
  },
  {
  quote: "What do you hunger for, young Sage?",
  character: "Subject One",
  advancement: "Dreadgod",
  book: "Reaper"
  },
  {
  quote: "Your brother didn’t take a Remnant at all",
  character: "Jai Long",
  advancement: "Truegold",
  book: "Reaper"
  },
  {
  quote: "The world is wide outside your narrow Paths, Let me guide you.",
  character: "Li Markuth",
  advancement: "Ascended",
  book: "Unsouled"
  },
  {
  quote: "So you haven’t returned. I left it mostly intact, out of respect.",
  character: "Reigan Shen",
  advancement: "Monarch",
  book: "Wintersteel"
  },
  {
  quote: "Lot of blood in that water, Do I have the Lord of the Dawnwing Sect back with me once again?",
  character: "Beast King",
  advancement: "Herald",
  book: "Ghostwater"
  },
  {
  quote: "That is called ghostwater!",
  character: "Dross",
  advancement: "Dross",
  book: "Ghostwater"
  },
  {
  quote: "Gentlemen, this is a mistake.",
  character: "Eithan",
  advancement: "Underlord",
  book: "Blackflame"
  },
  {
  quote: "What about you? What if you had to fight one of us?",
  character: "Yerin",
  advancement: "Underlord",
  book: "Uncrowned"
  },
  {
  quote: "You cut him. You hurt him. You made him bleed.",
  character: "Riyusai Meira",
  advancement: "Underlord",
  book: "Underlord"
  },
  {
  quote: "Don’t thank me yet, Once you’re a new Sage, then you can thank me.",
  character: "Eithan",
  advancement: "Underlord",
  book: "Uncrowned"
  },
  {
  quote: "Casting you out because of your Remnant. Give them a chance, and I’m sure they’ll take you back.",
  character: "Eithan",
  advancement: "Underlord",
  book: "Soulsmith"
  },
  {
  quote: "Is he paying the price to maintain them, or is it the labyrinth?",
  character: "Akura Malice",
  advancement: "Monarch",
  book: "Waybound"
  },
  {
  quote: "You have the congratulations of our clan, Wei Shi Lindon. There is honor in overcoming a deficiency to achieve victory.",
  character: "Wei Jin Sairus",
  advancement: "Jade",
  book: "Unsouled"
  },
  {
  quote: "No one pushes as hard as you do without a goal. Pardon me if I’m overstepping my bounds, but I’d like to know what destination you have in mind.",
  character: "Cassias Arelius",
  advancement: "Highgold",
  book: "Skysworn"
  },
  {
  quote: "No one pushes as hard as you do without a goal. Pardon me if I’m overstepping my bounds, but I’d like to know what destination you have in mind.",
  character: "Cassias Arelius",
  advancement: "Highgold",
  book: "Skysworn"
  },
  {
  quote: "They can't all be Underlords, You don't find an Underlord under every rock and tree stump",
    character: "Yerin",
    advancement: "Highgold",
    book: "Skysworn"
  },
  {
  quote: "No…matter Will…heal.",
  character: "Red Faith",
  advancement: "Sage",
  book: "Dreadgod"
  },
  {
  quote: "We’ve found bandits at my current location, We’re going to double back and take the alternate route. We expect a delay of no more than eight hours.",
  character: "Maten Kei",
  advancement: "Underlord",
  book: "Wintersteel"
  },
  {
  quote: "Bid welcome, to the last great descendant of Serpent’s Grave.",
  character: "Eithan",
  advancement: "Underlord",
  book: "Blackflame"
  },
   {
  quote: "Congratulations on your successful landing, captain.",
  character: "Lindon",
  advancement: "Truegold",
  book: "Blackflame"
  },
   {
  quote: "Nothing to be scared of, is there? He didn’t leave a Dreadgod tucked away.",
  character: "Yerin",
  advancement: "Herald",
  book: "Reaper"
  },
   {
  quote: "The Blackflame completed his mission,” Bai Rou said. “We will speak to you both, and that’s all you need to know.",
  character: "Bai Rou",
  advancement: "Truegold",
  book: "Ghostwater"
  },
   {
  quote: "Then I realized I’d realized it, and that was the beginning for me, wasn’t it? The ‘realization cascade,’ that’s what I call it! I don’t call it that.",
  character: "Dross",
  advancement: "Dross",
  book: "Ghostwater"
  },
   {
  quote: "Which of you fights first?",
  character: "Northstrider",
  advancement: "Monarch",
  book: "Uncrowned"
  },
  {
  quote: "You deserve to die a thousand times!",
  character: "Seishen Daji",
  advancement: "Underlord",
  book: "Wintersteel"
  },
  {
  quote: "You don’t think I have enough to worry about? Go. Go! If you bother me again, I’ll set the spiders on you.",
  character: "Fisher Gesha",
  advancement: "Highgold",
  book: "Soulsmith"
  },
  {
  quote: "Dross…thank you. You saved us.",
  character: "Lindon",
  advancement: "Overlord",
  book: "Bloodline"
  },
  {
  quote: "Cowardice is not fitting for warriors of Heaven’s Glory. That is not the Sword Sage, it is only a Remnant.",
  character: "Elder Whitehall",
  advancement: "Jade",
  book: "Unsouled"
  },
   {
  quote: "But cleverness is an unstable foundation. Wisdom, loyalty, strength…in the sacred arts, only these things are firm.",
  character: "Elder Rahm",
  advancement: "Jade",
  book: "Unsouled"
  },
   {
  quote: "We called it the Void Dragon’s Dance, In one moment, the flames devour everything on the battlefield, leaving only smoke and dust.",
  character: "Orthos",
  advancement: "Truegold",
  book: "Blackflame"
  },
   {
  quote: "We’re going to the very outskirts of imperial territory, People there have forgotten about the Empire.",
  character: "Jai Chen",
  advancement: "Foundation",
  book: "Skysworn"
  },
   {
  quote: "Fear not, I have come for you.",
  character: "Suriel",
  advancement: "Ascended",
  book: "Underlord"
  },
   {
  quote: "People love to follow the strong. You have to show them your power…but not just show them. They have to feel it. You have to grind it into them, so that your strength is as present and undeniable as the sun. ",
  character: "Mu Enkai",
  advancement: "Lowgold",
  book: "Ghostwater"
  },
   {
  quote: "Am I missing something? Do you think Eithan left him to side with the Dreadgods?",
  character: "Akura Mercy",
  advancement: "Overlord",
  book: "Dreadgod"
  },
   {
  quote: "We're a bad match. I have virtually no defense against your Path, so if you had a real sword, I'd have to keep my distance. When you don't, either I'm too fast or you're too strong.",
  character: "Naru Saeya",
  advancement: "Uncrowned",
  book: "Underlord"
  },
  {
  quote: "You’re thinking about it like it’s a sacred arts technique. You’re working on a conceptual level now. Don’t cling to literal definitions.",
  character: "Eithan",
  advancement: "Archlord",
  book: "Bloodline"
  },
   {
  quote: "They are not. She…tricked me.",
  character: "Akura Grace",
  advancement: "Underlord",
  book: "Wintersteel"
  },
   {
  quote: "Lindon, I keep my promises.",
  character: "Silent King",
  advancement: "Dreadgod",
  book: "Dreadgod"
  },
   {
  quote: "The empire prides itself on its appearance, and we are the ones who keep it beautiful.",
  character: "Cassias Arelius",
  advancement: "Highgold",
  book: "Blackflame"
  },
   {
  quote: "You disrespect your elders, Shi Lindon.",
  character: "Wei Jin Sairus",
  advancement: "Jade",
  book: "Bloodline"
  },
   {
  quote: "This isn’t fair,You all know Enforcer techniques are my weakness. That, and fine imported silk.",
  character: "Eithan",
  advancement: "Archlord",
  book: "Reaper"
  },
   {
  quote: "Did you get that sword from your master?",
  character: "Akura Mercy",
  advancement: "Lowgold",
  book: "Ghostwater"
  },
   {
  quote: "Something is wrong with your home,",
  character: "Orthos",
  advancement: "Truegold",
  book: "Uncrowned"
  },
   {
  quote: "I cannot kill him, and I fear that when I die, his family will tear mine apart.",
  character: "Jai Daishou",
  advancement: "Underlord",
  book: "Skysworn"
  },
   {
  quote: "He came here looking for recruits, and he thinks we’d be…suitable.",
  character: "Lindon",
  advancement: "Iron",
  book: "Soulsmith"
  },
   {
  quote: "There are three steps to reaching Underlord. Mastering yourself, mastering the world around you, and then connecting yourself to the world. It’s the third step that’s the most mysterious.",
  character: "Eithan",
  advancement: "Underlord",
  book: "Underlord"
  }
];

export const getDailyQuoteIndex = () => {
  const startDate = new Date('2025-10-15'); // Start date
  const today = new Date();
  const diffTime = Math.abs(today - startDate);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays % QUOTES_DATA.length;
};

export const getTodaysQuote = () => {
  const index = getDailyQuoteIndex();
  return QUOTES_DATA[index];
};